import React from 'react'
import styled from 'styled-components'
import UnstyledDropZone from 'react-dropzone'
import Button from '../../components/Button'

const DropZone = styled(UnstyledDropZone)`
  text-align: center;
  border: 1px dashed grey;
  padding: 1em;
`
const ImagePreview = styled.div`
  padding: 1em;
  img {
    width: 7em;
    margin-right: 0.5em;
  }
`

const UploadScreen = ({ images, goToPanel, handleImageDrop }) => (
  <div>
    <h3>Upload Image</h3>
    <DropZone onDrop={handleImageDrop}>
      Drop Files here
      <br />
      or
      <br />
      <Button>Select Files</Button>
    </DropZone>
    {images && (
      <ImagePreview>
        {images.map(({ file }, i) => <img key={i} src={file.preview} alt="" />)}
      </ImagePreview>
    )}
    <p>Note: Image format must be JPG, JPEG, or PNG.</p>
    <Button
      style={{ display: 'block', marginLeft: 'auto' }}
      disabled={!images}
      onClick={goToPanel('tag-images')}>
      Continue
    </Button>
  </div>
)

export default UploadScreen



// WEBPACK FOOTER //
// ./src/components/ImageSelectionModal/UploadScreen.js